import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser"
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode"
import { UnavailabilityReason } from "../../../../../../Wrap/Constants/Enums/Domain/UnavailabilityReason"
import { FlexiConversionUnavailabilityReason } from "../../../../../../Wrap/Constants/Enums/Drawdown/FlexiConversionUnavailabilityReason"
import { ConvertCappedToFlexiModel } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/ConvertCappedToFlexiModel"

export const convertToFlexiStepperName = {
    selectArrangement: "Select arrangements to convert",
    review: "Review",
    confirmation: "Confirmation"
}

export const SelectArrangementInformationText = {
    warningMessageHeading : "Important information",
    warningMessageBody: "If any or all arrangements are unavailable to convert, the unavailability reason is detailed below and will need to be addressed or completed before conversion can take place. The link below provides additional information on converting to flexible drawdown.",
    popUpMessage: "When an arrangement is converted from capped drawdown to flexible drawdown and the first income is taken under flexible drawdown and the money purchase annual allowance is triggered, this reduces your annual allowance and therefore the amount you are able to contribute before a tax charge may be applicable."
}

export const ReviewStepInformationText =
"We will convert each drawdown account into flexible drawdown, retaining the existing arrangement id."

export const AdviserDeclaractionText = {
    messagePart1 : "I can confirm on behalf of ",
    messagePart2: " that my client has instructed the conversion to a flexible account."
}

export const unavailabilityReasonsMap = {
    [FlexiConversionUnavailabilityReason.NotSpecified]: "Not specified",
    [FlexiConversionUnavailabilityReason.Within20DaysGADReview]: "Within 20 Days GAD Review",
    [FlexiConversionUnavailabilityReason.IncomeWithdrawalInProgress]: "Income Withdrawal In Progress",
    [FlexiConversionUnavailabilityReason.ZeroAssetOrCashBalance]: "Zero Asset Or Cash Balance",
    [FlexiConversionUnavailabilityReason.OrdersInProgress]: "Orders In Progress",
    [FlexiConversionUnavailabilityReason.ElectiveOrComplexCorporateActionsInProgress]: "Elective Or Complex Corporate Actions In Progress",
    [FlexiConversionUnavailabilityReason.ExistingProcessOngoing]: "Existing Process Ongoing",
    [FlexiConversionUnavailabilityReason.IsDependantArrangement]: "Is Dependant Arrangement",
    [FlexiConversionUnavailabilityReason.InProgressRegularCrystallisation]: "In Progress Regular Drawdown",
    [FlexiConversionUnavailabilityReason.ModelPortfolioInvestmentsHasNegativeValue]: "Model Portfolio Investments Has Negative Value",
    [FlexiConversionUnavailabilityReason.ModelPortfolioInvestmentsHasOpenOrders]: "Model Portfolio Investments Has Open Orders",
    [FlexiConversionUnavailabilityReason.ArrangementNotActive]: "Account not active",

}
